(function() {
	'use strict';

	angular.module('quantixApp').controller('ClientDetailsController',
			ClientDetailsController);

	ClientDetailsController.$inject = [ '$scope', 'Principal', '$state',
			'ClientListService', '$rootScope', '$stateParams', '$timeout',
			'$uibModal', '$rootScope', 'MappingWithRissService','$window' ];

	function ClientDetailsController($scope, Principal, $state,
			ClientListService, $rootScope, $stateParams, $timeout, $uibModal,
			MappingWithRissService,$window) {
		var vm = this;
		vm.clientCode = $stateParams.clientCode;

		var clientLicenseGrid = '';
		var userMovementGrid = '';

		$scope.init = function() {
			$scope.getClientDetails();

		};

		$scope.getClientDetails = function() {

			$scope.gridData = [];
			$scope.rissProductList = [];
			$scope.dataProductList = [];
			ClientListService
					.getClientDetails(vm.clientCode)
					.then(
							function(result) {

								$scope.companyDetails = result;

								$scope.licenceGridData = [];
								$scope.productData = [];
								angular
										.forEach(
												$scope.companyDetails.mapedData,
												function(value1, key) {
													var fields = value1.rissProductId
															.substring(
																	0,
																	value1.rissProductId.length - 1)
															.split(',');
													for (var i = 0; i < fields.length; i++) {
														if (fields[i] != "") {
															$scope.rissProductList
																	.push(fields[i]);
														}
													}

													var dataProduct = value1.productId
															.substring(
																	0,
																	value1.productId.length - 1)
															.split(',');
													for (var i = 0; i < dataProduct.length; i++) {
														// if(dataProduct[i]!=""){
														$scope.dataProductList
																.push(dataProduct[i]);
														// }
													}
													for (var i = 0; i < $scope.rissProductList.length; i++) {
														$scope.licenceGridData
																.push({
																	licenceKey : key
																			.substring(
																					12,
																					key.length - 1),
																	productId : $scope.dataProductList[i],
																	rissProductId : $scope.rissProductList[i],
																	ipAddress : value1.ipAddress
																			.substring(
																					0,
																					value1.ipAddress.length - 2),
																	isTrialSubscription : value1.isTrialSubscription,
																	subIsTerminated : value1.IsTerminatedSubscription,
																	userType : value1.userType,
																	subToDate : value1.subToDate,
																	subFromDate : value1.subFromDate,
																	subGraceDate : value1.subGraceDate,
																	subscriptionId : value1.subscriptionId,
																	clientId : value1.clientId
																})
													}

												});

								angular
										.forEach(
												$scope.userData,
												function(value1, key1) {
													angular
															.forEach(
																	$scope.licenceGridData,
																	function(
																			value2,
																			key2) {
																		if (value2.licenceKey == value1.userLicenceKey) {
																					$scope.userData[key1].productId = value2.productId,
																					$scope.userData[key1].ipAddress = value2.ipAddress,
																					$scope.userData[key1].isTrialSubscription = value2.isTrialSubscription,
																					$scope.userData[key1].subIsTerminated = value2.subIsTerminated,
																					$scope.userData[key1].userType = value2.userType,
																					$scope.userData[key1].subToDate = value2.subToDate,
																					$scope.userData[key1].subFromDate = value2.subFromDate,
																					$scope.userData[key1].subGraceDate = value2.subGraceDate
																		}

																	});
												});

								$scope.userMovementGridData = {
									dataProvider : $scope.userData,
									delegate : $scope

								};

								$scope.clientLicenseGridData = {

									dataProvider : $scope.licenceGridData,
									delegate : $scope

								};
							});
		}
		$scope.clientLicenseGridCompletion = function(event) {
			clientLicenseGrid = event.target;
			clientLicenseGrid.validateNow();
		};
		$scope.userMovementGridCompletion = function(event) {
			userMovementGrid = event.target;
			userMovementGrid.validateNow();
		};

		$scope.getUserMovementData = function() {

			$timeout(function() {
				ClientListService.getUserMovementList(vm.clientCode).then(
						function(data) {
							$scope.userData = data;
						}, function(errordata) {
							console.log("Some thing went wrong!");
						});

			}, 40);
		}
		$window.mappingOfdatProductwithRissProduct= function(item) {

			var licenseKey = item.id;
			var companyName = scope.companyDetails.clientName;
			item.href = window.location;
			scope.mappingOfdatProductwithRissProduct(licenseKey, companyName)
		};
		$scope.init();
		$scope.getUserMovementData();

		$scope.getMappingHyperLink = function(item, column) {
			if (item.rissProductId != " "
					&& (item.productId == null || item.productId == " "
							|| item.productId == undefined || item.productId == "")) {
				$scope.rissProductId = item.rissProductId;
				$scope.clientId = item.clientId;
				$scope.subId = item.subscriptionId;
				return ('<div><a href="" onClick="mappingOfdatProductwithRissProduct(this)"  id='
						+ item.licenceKey + '>Please map Product</a></div>');

			} else if (item.productId != "") {
				return ('<div>' + item.productId + '</div>');
			}
		}
		$scope.mappingOfdatProductwithRissProduct = function(licenceKey,
				companyName) {
			$rootScope.licenseKey = licenceKey;
			$rootScope.companyName = companyName;
			$rootScope.rissProductId = $scope.rissProductId;
			$rootScope.subCode = $scope.subId;
			$rootScope.clientId = $scope.clientId;

			ClientListService.getDataProductList().then(function(result) {
				$rootScope.products = result;
			});
			$uibModal.open({
				templateUrl : 'app/admin/clientList/mappingWithRISS.html',
				controller : 'MappingWithRISSController',
				controllerAs : 'vm',
				size : 'lg',

			}).closed.then(function() {
				$scope.getClientDetails();
			});
		}
	}

})();
